module.exports = __webpack_public_path__ + "resources/img/27018.f931cd06359c3a95ca36b4149bb701a0.png";